import DetailTitle from "@/components/DetailTitle"
import styles from './index.module.scss'
import { Table } from 'antd';
import intl from "react-intl-universal";
const Contributors = ({ contributor }) => {
	const columns = [
		{
			title: intl.get('User.Full Name'),
			key: 'nickname',
			dataIndex: 'nickname',
			render: (text, record) => {
				return <a href="#">{text}</a>
			},
		},
		{
			title: intl.get('Register.Organization'),
			key: 'oranization',
			dataIndex: 'organization',
		},
		{
			title: intl.get('Register.Country/Region'),
			key: 'country',
			dataIndex: 'country',
		},
		{
			title: intl.get('Email'),
			key: 'email',
			dataIndex: 'email',
		},
	];
	return (
		<div className={styles.contributorBox}>
			<DetailTitle title="Contributor" />
			<p>
				{intl.get("Share.contributorDes")}
			</p>
			<Table
				rowKey={record => record.uuid}
				size="small"
				pagination={false}
				dataSource={contributor}
				columns={columns} />
		</div>
	)
}
export default Contributors;